import type { FC } from "react"
import React, { useState } from "react"

import { useTranslation } from "react-i18next"
import { atom, useRecoilState } from "recoil"

import Button from "~/components/Button"
import { useDesignRequest } from "~/containers/Proposal/state/design-request/use-design-request"
import { getPowurUrl } from "~/utils/getUrlForEnvironment"

import { DrawerContainer } from "."
import { Footer, StyledForm, Wrapper } from "./DesignRevision"

export const EscalationDrawerIsOpenState = atom<boolean>({
  key: `EscalationDrawerIsOpen`,
  default: false,
})

const EscalationDrawer_Internal: FC = () => {
  const { t } = useTranslation()
  const [escalationDrawerIsOpen, setEscalationDrawerIsOpen] = useRecoilState(
    EscalationDrawerIsOpenState,
  )
  const { escalate } = useDesignRequest()
  const [details, setDetails] = useState(``)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!escalationDrawerIsOpen) return
    await escalate(details)
    setEscalationDrawerIsOpen(false)
    window.location.replace(`${getPowurUrl()}/admin-solar-proposals/vision`)
  }

  return (
    <DrawerContainer
      isOpen={escalationDrawerIsOpen}
      close={() => setEscalationDrawerIsOpen(false)}
      title={t(`requestEscalation`)}
    >
      <Wrapper>
        <StyledForm onSubmit={handleSubmit}>
          <p>{t(`escalationDesc`)}</p>
          <textarea
            name="details"
            id="details"
            cols={30}
            rows={10}
            placeholder={t(`escalationPlaceholder`)}
            onChange={(e) => setDetails(e.target.value)}
          />
          <Footer>
            <Button
              style={{ border: `1px solid #0066f8` }}
              type="button"
              onClick={() => setEscalationDrawerIsOpen(false)}
            >
              {t(`cancel`)}
            </Button>
            <Button disabled={/^\s*$/.test(details)} type="submit">
              {t(`requestEscalation`)}
            </Button>
          </Footer>
        </StyledForm>
      </Wrapper>
    </DrawerContainer>
  )
}
export const EscalationDrawer = React.memo(EscalationDrawer_Internal)
